import React, { useState } from 'react'
import { Link } from 'react-router-dom'
import { supabase } from '../../config/supabase'
import { motion } from 'framer-motion'
import SafeIcon from '../../common/SafeIcon'
import * as FiIcons from 'react-icons/fi'

const { FiMail, FiArrowLeft } = FiIcons

const ForgotPassword = () => {
  const [email, setEmail] = useState('')
  const [loading, setLoading] = useState(false)
  const [error, setError] = useState('')
  const [success, setSuccess] = useState(false)

  const handleSubmit = async (e) => {
    e.preventDefault()
    setError('')
    setSuccess(false)
    setLoading(true)

    try {
      const { error } = await supabase.auth.resetPasswordForEmail(email, {
        redirectTo: `${window.location.origin}/#/login`,
      })

      if (error) throw error
      setSuccess(true)
    } catch (error) {
      console.error('Reset password error:', error)
      setError(error.message)
    } finally {
      setLoading(false)
    }
  }

  return (
    <div className="min-h-screen flex items-center justify-center from-blue-50 to-indigo-100 gradient-bg">
      <motion.div
        initial={{ opacity: 0, y: 20 }}
        animate={{ opacity: 1, y: 0 }}
        className="bg-white p-8 rounded-2xl shadow-xl w-full max-w-md"
      >
        <div className="text-center mb-8">
          <div className="bg-[#D59A4C30] p-4 rounded-full w-16 h-16 mx-auto mb-4">
            <SafeIcon icon={FiMail} className="w-8 h-8 text-[#D59A4C]" />
          </div>
          <h1 className="text-3xl font-bold text-gray-900 mb-2">
            Request Login Link
          </h1>
          <p className="text-gray-600">
            Enter your email to receive a secure login link
          </p>
        </div>

        {success ? (
          <div className="text-center">
            <div className="bg-green-50 text-green-800 p-4 rounded-lg mb-6">
              <p>Login instructions have been sent to your email.</p>
              <p className="mt-2 text-sm">
                Please check your inbox and follow the link to log in to your account.
              </p>
            </div>
            <Link
              to="/login"
              className="inline-flex items-center text-[#D59A4C] hover:text-[#B58C54]"
            >
              <SafeIcon icon={FiArrowLeft} className="w-4 h-4 mr-2" />
              Back to Sign In
            </Link>
          </div>
        ) : (
          <form onSubmit={handleSubmit} className="space-y-6">
            <div>
              <label className="block text-sm font-medium text-gray-700 mb-2">
                Email Address
              </label>
              <input
                type="email"
                value={email}
                onChange={(e) => {
                  setEmail(e.target.value)
                  setError('')
                }}
                className={`w-full px-4 py-3 border rounded-lg focus:ring-2 focus:ring-[#D59A4C] focus:border-transparent ${
                  error ? 'border-red-500' : 'border-gray-300'
                }`}
                required
              />
            </div>

            {error && (
              <div className="text-red-600 text-sm bg-red-50 p-3 rounded-lg">
                {error}
              </div>
            )}

            <button
              type="submit"
              disabled={loading}
              className="w-full bg-[#D59A4C] text-white py-3 px-4 rounded-lg hover:bg-[#B58C54] disabled:opacity-50 disabled:cursor-not-allowed transition-colors"
            >
              {loading ? 'Sending...' : 'Send Login Link'}
            </button>

            <div className="text-center">
              <Link
                to="/login"
                className="inline-flex items-center text-[#D59A4C] hover:text-[#B58C54]"
              >
                <SafeIcon icon={FiArrowLeft} className="w-4 h-4 mr-2" />
                Back to Sign In
              </Link>
            </div>
          </form>
        )}
      </motion.div>
    </div>
  )
}

export default ForgotPassword